// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - LIST ITEM ICON ||============================== //

export default function ListItemButton(theme: Theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.action.selected
          },
          // Não aplicar fundo cinza para menus do sidebar (usam SidebarMenuButton)
          // O SidebarMenuButton aplica seu próprio estilo com !important
          '&.Mui-selected[data-sidebar-menu="true"]': {
            backgroundColor: 'transparent' // Será sobrescrito pelo estilo do SidebarMenuButton
          },
          '& .MuiListItemIcon-root': {
            color: theme.palette.primary.main
          }
        }
      }
    }
  };
}
